var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { forwardRef, } from 'react';
import Spinner from '../spinner';
import { ButtonContainer, ButtonHideContainer, ButtonLoadingContainer, } from './styles/button.styled';
const Button = forwardRef((_a, ref) => {
    var { className, children, color, variant = 'on-light', dataTest = `button-${color}`, size = 'normal', type = 'button', href, loading = false, disabled = false } = _a, props = __rest(_a, ["className", "children", "color", "variant", "dataTest", "size", "type", "href", "loading", "disabled"]);
    return (_jsx(ButtonContainer, Object.assign({ "$variant": variant, "$color": color, "$size": size, className: className, "data-test": dataTest, tagName: href !== undefined ? 'a' : 'button', inputRef: ref, disabled: disabled || loading }, (href === undefined ? { type } : { href }), props, { children: loading ? (_jsxs(_Fragment, { children: [_jsx(ButtonHideContainer, { children: children }), _jsxs(ButtonLoadingContainer, { "$variant": variant, children: [_jsx(Spinner, { size: "small", inverted: variant !== 'on-light' }), children] })] })) : (children) })));
});
Button.displayName = 'Button';
export default Button;
